import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, Output, AfterViewChecked } from '@angular/core';
import { PopupFactory } from '../popup-factory';
import { ResizableEvent } from '../../directives/resizable/resizable.directive';
import { Repository } from '../../../modules/repository/repository';
import { RepositoryManager } from '../../../modules/repository/repository.manager';
import { ListFactory } from '../../caches/list.factory';
import { ObjectUtil } from '../../utils/object.util';
import { Router } from '@angular/router';
import { SessionFactory } from '../../caches/session.factory';
import { ServiceManager } from '../../services/service.manager';
import { LocalStorageService } from '../../services/localstorage.service';
import { NavigateUtil } from '../../utils/navigate.util';
import { DMWFactory } from 'src/app/modules/design/dataflow/dmw/dmw.factory';
import { UnsavedObjectPopupObj } from '../../models/objs/unsavedobjectpopupobj';
import { ToastrMessage } from '../../services/toastr.message';
import { SubjectService } from '../../services/subject.service';

@Component({
  selector: 'app-unsavedobjects-popup',
  templateUrl: './unsavedobjects-popup.component.html',
})
export class UnsavedObjectsPopupComponent implements OnInit, AfterViewChecked {
  @ViewChild('unsavedObjectsPopupId') unsavedObjectsPopupId: ElementRef;
  @ViewChild('unsavedObjectsPopupHeader') unsavedObjectsPopupHeader: ElementRef;
  @ViewChild('unsavedObjectsPopupBody') unsavedObjectsPopupBody: ElementRef;
  @ViewChild('unsavedObjectsPopupFooter') unsavedObjectsPopupFooter: ElementRef;

  @Input() title: string;
  @Input() scrollTop: boolean;
  @Input() backdrop: boolean;
  @Input() selectedItemsLength: number;
  @Output() closeEventEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() applyMethodEmitter: EventEmitter<any> = new EventEmitter();

  isShowMore: boolean;
  unsavedObjects: Array<any>;
  unsavedObjectPopupObj: UnsavedObjectPopupObj;

  popupFactory: PopupFactory;
  repository: Repository;
  listFactory: ListFactory;
  sessionFactory: SessionFactory;
  methodName: string;
  methodArgs: Array<any>;
  url: string;
  urlParams: Array<any>;
  invalidMsg: string;
  dMWFactory: DMWFactory;

  undoDoubleClick: boolean
  forcibleDelete: boolean;
  objectUtil: ObjectUtil;
  refreshCount: number;
  constructor(private repositoryManager: RepositoryManager,
    private router: Router,
    private toastrMessage: ToastrMessage,
    private serviceManager: ServiceManager,
    private localStorageService: LocalStorageService,
    private subjectService: SubjectService) {
    this.popupFactory = new PopupFactory();
    this.listFactory = ListFactory.getInstance();
    this.sessionFactory = SessionFactory.getInstance();
    this.objectUtil = ObjectUtil.getInstance();
    this.dMWFactory = DMWFactory.getInstance();
    this.scrollTop = true;
    this.backdrop = true;

    this.refreshCount = 0;
    this.unsavedObjects = new Array<any>();
    this.setDefaults();
  }

  setDefaults(): void {
    this.methodName = "";
    this.methodArgs = new Array<any>();
    this.url = "";
    this.urlParams = new Array<any>();
    this.invalidMsg = '';

    this.undoDoubleClick = false;

    this.isShowMore = false;
    this.unsavedObjects.splice(0, this.unsavedObjects.length);

    this.forcibleDelete = false;
  }

  ngOnInit(): void {
    const modals = document.querySelectorAll('.ui-modal');
    this.popupFactory.disablePopupBackground(modals);
  }

  ngAfterViewChecked(): void {
    this.popupFactory.restorePopup(this.unsavedObjectsPopupId.nativeElement);
  }

  show(unsavedObjectPopupObj: UnsavedObjectPopupObj = new UnsavedObjectPopupObj()): void {
    this.popupFactory.executePostDisplayActions = true;
    this.popupFactory.visible = true;
    this.center();
    this.unsavedObjectPopupObj = unsavedObjectPopupObj;

    this.setDefaults();
    this.showMore();
  }

  discard(): void {
    this.repositoryManager.revert()
      .subscribe(() => {
        this.repositoryManager.setChange_Ind();
        this.toastrMessage.showSuccessToastr('Object(s) has been reverted successfully.');
        this.subjectService.setRefreshListScreen(this.refreshCount);

        if (this.unsavedObjectPopupObj.isNeedMethodEmit) {
          this.applyMethodEmitter.emit(this.unsavedObjectPopupObj);
        }

        if (this.listFactory.movedToUrl != '' && !this.listFactory.changeFldr) {
          this.router.navigateByUrl(this.listFactory.movedToUrl);
          this.listFactory.movedToUrl = '';
        }

        if (this.listFactory.changeFldr && this.listFactory.movedToUrl != '') {
          this.moveToAnotherProject();
        }
        let url: string = window.location.href;
        if (url.indexOf('dmw') != -1) {
          this.dMWFactory.isCloseClicked = true;
        }
        this.closePopup();
      });
  }

  save(): void {
    this.repositoryManager.save()
      .subscribe(diMsgObj => {
        if (diMsgObj.error_Cd != "0") {
          if (diMsgObj.error_Cd == "ESM00080" || diMsgObj.error_Cd == "ESM00690") {
            this.listFactory.opendependenciesPopupId.show(diMsgObj.retMsgObjects);
          }
          return;
        }

        this.repositoryManager.setChange_Ind();

        this.toastrMessage.showSuccessToastr('Object(s) has been saved successfully.');
        this.subjectService.setRefreshListScreen(this.refreshCount);
        if (this.unsavedObjectPopupObj.isNeedMethodEmit) {
          this.applyMethodEmitter.emit(this.unsavedObjectPopupObj);
        }

        if (this.listFactory.movedToUrl != '' && !this.listFactory.changeFldr) {
          this.router.navigateByUrl(this.listFactory.movedToUrl);
          this.listFactory.movedToUrl = '';
        }

        if (this.listFactory.changeFldr && this.listFactory.movedToUrl != '') {
          this.moveToAnotherProject();
        }
        let url: string = window.location.href;
        if (url.indexOf('dmw') != -1) {
          this.dMWFactory.isCloseClicked = true;
        }
        this.closePopup();
      });
  }

  showMore(): void {
    //DDS-9556
    // this.isShowMore = !this.isShowMore;
    // if (!this.isShowMore) return;

    this.unsavedObjects.splice(0, this.unsavedObjects.length);

    let _unsavedObjects = this.repositoryManager.repository.fldrObjectWrapper.fldrObject.getUnSavedObjects()
    for (let i: number = 0; i < _unsavedObjects.length; i++) {
      let object: any = {
        'name': this.objectUtil.getName(_unsavedObjects[i]),
        'objectName': this.objectUtil.getObjectName(_unsavedObjects[i])
      }
      this.unsavedObjects.push(object);
    }
  }

  cancel(): void {
    this.listFactory.movedToUrl = '';
    this.listFactory.changeFldr = null;

    this.closePopup();
  }

  moveToAnotherProject(): void {
    this.serviceManager.unlockOnFldr(this.sessionFactory.fldr.fldr_Id)
      .subscribe(diMsgObj => {
        if (diMsgObj.error_Cd != "0") {
          return;
        }
        this.sessionFactory.updateFldr(this.listFactory.changeFldr);
        this.repositoryManager.repository.fldrObjectWrapper.clear();
        this.localStorageService.clear();
        this.localStorageService.setObject('fldr_Id', this.listFactory.changeFldr.fldr_Id);

        this.listFactory.changeFldr = null;
        this.router.navigateByUrl(this.listFactory.movedToUrl);
        this.listFactory.movedToUrl = '';
      });
  }

  closePopup(): void {
    this.popupFactory.visible = false;
    this.closeEventEmitter.emit(true);
  }

  center(): void {
    this.popupFactory.center(this.unsavedObjectsPopupId.nativeElement);
  }

  onCloseIcon(event: Event): void {
    event.stopPropagation();
  }

  onResize(event: ResizableEvent): void {
    this.popupFactory.onResize(event, this.unsavedObjectsPopupHeader.nativeElement,
      this.unsavedObjectsPopupFooter.nativeElement, this.unsavedObjectsPopupId.nativeElement,
      this.unsavedObjectsPopupBody.nativeElement);
  }

  toggleMaximize(event): void {
    this.popupFactory.toggleMaximize(event, this.unsavedObjectsPopupHeader.nativeElement,
      this.unsavedObjectsPopupFooter.nativeElement, this.unsavedObjectsPopupId.nativeElement,
      this.unsavedObjectsPopupBody.nativeElement);
  }
}